const LockBody = (option) => {
  if (option === true) {
    const top = window.pageYOffset
    document.body.style.top = `-${top}px`
    document.body.style.position = 'fixed'
    document.body.classList.add('body-locked')
  } else {
    if (document.body.style.position !== 'fixed') return
    const top = document.body.style.top
    document.body.style.position = ''
    document.body.style.top = ''
    window.scrollTo(0, parseInt(top || '0', 10) * -1)
    document.body.classList.remove('body-locked')
  }
}

const ShowHide = {
  init: () => {
    document.addEventListener('click', ShowHide.handler)
    document.addEventListener('keydown', ShowHide.closeOverlays)
  },
  handler: (event) => {
    if (!event.target.hasAttribute('data-active-trigger')) return

    // event.preventDefault()
    const eventTarget = (event.target.hasAttribute('data-active-trigger')) ? event.target : event.target.parentNode
    const targets = (eventTarget.getAttribute('data-active-trigger')) ? eventTarget.getAttribute('data-active-trigger').split(',') : [eventTarget]

    for (let i = 0; i < targets.length; i += 1) {
      const target = document.querySelector(targets[i])
      const activeClass = target.getAttribute('data-active-class').split(' ') ?? []

      // * reset group elements
      if (target.hasAttribute('data-active-group')) {
        const groupTargets = document.querySelectorAll(`[data-active-group="${target.getAttribute('data-active-group')}"]`)
        for (let x = 0; x < groupTargets.length; x += 1) {
          if (target !== groupTargets[x]) {
            ShowHide.toggleClass(groupTargets[x], activeClass)
            groupTargets[x].classList.remove('active')
          }
        }
      }

      // * toggle class
      ShowHide.toggleClass(target, activeClass)

      // * remove active
      if (target.classList.contains('active')) {
        target.classList.remove('active')
        
        // * reset aria attrs
        if (target.id) {
          ShowHide.setAria(document.querySelectorAll(`[aria-controls='${target.id}']`), false)
        }
        // * lockbody
        if (target.hasAttribute('data-watch-close')) {
          LockBody(false)
          target.tabIndex = -1
        }
      } else {
        // * add active
        target.classList.add('active')

        // * reset aria attrs
        if (target.id) {
          ShowHide.setAria(document.querySelectorAll(`[aria-controls='${target.id}']`), true)
        }
        // * lockbody
        if (target.hasAttribute('data-watch-close')) {
          LockBody(true)
          target.tabIndex = 1
          target.focus({
            preventScroll: true,
          })
        }
      }
    }
  },
  toggleClass: (target, classes) => {
    // console.log('toggling target', target)
    for (let i = 0; i < classes.length; i += 1) {
      target.classList.toggle(classes[i])
      // console.log('toggled', target.classList)
    }
  },
  setAria: (el, bool) => {
    if (el) {
      for (let i = 0; i < el.length; i += 1) {
        el[i].setAttribute('aria-expanded', bool)
      }
    }
  },
  closeOverlays: (event) => {
    if (!document.body.classList.contains('body-locked')) return

    const key = event.key || event.keyCode
    if (key === 'Escape' || key === 'Esc' || key === 27) {
      const target = document.querySelector('[data-watch-close].active')
      const controllers = document.querySelectorAll(`[aria-controls="${target.id}"]`)

      for (let i = 0; i < controllers.length; i += 1) {
        controllers[i].classList.remove('active')
        controllers[i].setAttribute('aria-expanded', 'false')

        if (controllers[i].hasAttribute('data-active-class')) {
          const activeClass = controllers[i].getAttribute('data-active-class').split(' ')
          ShowHide.toggleClass(controllers[i], activeClass)
        }
      }
      target.tabIndex = -1

      if (target.classList.contains('active')) {
        target.classList.remove('active')
      } else {
        target.classList.add('active')
      }
      if (target.hasAttribute('data-active-class')) {
        const activeClass = target.getAttribute('data-active-class').split(' ')
        ShowHide.toggleClass(target, activeClass)
      }
      LockBody(false)
    }
  },
}
export default ShowHide